module.exports = __webpack_public_path__ + "img/open-err.7fee0928.png";